import { Navigate } from 'react-router-dom'
import { isProfissional } from '@/utils/profissionalAuth'
import { setAuthNotice } from '@/utils/authFlow'
import { useSessionExpiryWatch } from '@/hooks/useSessionExpiryWatch'

interface RequireProfissionalAuthProps {
  children: React.ReactNode
}

export function RequireProfissionalAuth({ children }: RequireProfissionalAuthProps) {
  useSessionExpiryWatch()

  if (!isProfissional()) {
    setAuthNotice('profissional', 'Sessão do profissional inválida ou expirada. Faça login novamente.')
    return <Navigate to="/profissional" replace />
  }
  return <>{children}</>
}

